import React, { useState, useEffect } from "react";

function Schemes() {
  const [schemes, setSchemes] = useState([]);
  const [members, setMembers] = useState([]);
  const [showSchemeForm, setShowSchemeForm] = useState(false);
  const [showMemberForm, setShowMemberForm] = useState(false);
  const [showBreakModal, setShowBreakModal] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [breakForm, setBreakForm] = useState({
    withdrawnByCustomer: false,
    withdrawAmount: "",
  });
  const [schemeForm, setSchemeForm] = useState({
    name: "",
    description: "",
    durationMonths: "",
    monthlyAmount: "",
    bonusType: "",
  });
  const [memberForm, setMemberForm] = useState({
    schemeId: "",
    customerName: "",
    customerPhone: "",
    startDate: "",
    maturityDate: "",
    monthlyAmount: "",
  });

  useEffect(() => {
    fetch(`/api/schemes?userId=${parseInt(localStorage.getItem("userId"))}`)
      .then((r) => r.json())
      .then((d) => setSchemes(d));
    fetch(
      `/api/schemes/members?userId=${parseInt(localStorage.getItem("userId"))}`,
    )
      .then((r) => r.json())
      .then((d) => setMembers(d));
  }, []);

  const saveScheme = () => {
    fetch(`/api/schemes?userId=${parseInt(localStorage.getItem("userId"))}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ...schemeForm,
        durationMonths: parseInt(schemeForm.durationMonths),
        monthlyAmount: parseFloat(schemeForm.monthlyAmount),
        isActive: true,
      }),
    })
      .then((r) => r.json())
      .then((d) => {
        setSchemes([...schemes, d]);
        setShowSchemeForm(false);
        setSchemeForm({
          name: "",
          description: "",
          durationMonths: "",
          monthlyAmount: "",
          bonusType: "",
        });
      });
  };

  const saveMember = () => {
    fetch(
      `/api/schemes/members?userId=${parseInt(localStorage.getItem("userId"))}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...memberForm,
          schemeId: parseInt(memberForm.schemeId),
          monthlyAmount: parseFloat(memberForm.monthlyAmount),
        }),
      },
    )
      .then((r) => r.json())
      .then((d) => {
        setMembers([...members, d]);
        setShowMemberForm(false);
        setMemberForm({
          schemeId: "",
          customerName: "",
          customerPhone: "",
          startDate: "",
          maturityDate: "",
          monthlyAmount: "",
        });
      });
  };

  const toggleScheme = (id) => {
    fetch(`/api/schemes/${id}/toggle`, { method: "PUT" })
      .then((r) => r.json())
      .then((updated) =>
        setSchemes(schemes.map((s) => (s.id === id ? updated : s))),
      );
  };

  const openBreakModal = (member) => {
    setSelectedMember(member);
    setBreakForm({ withdrawnByCustomer: false, withdrawAmount: "" });
    setShowBreakModal(true);
  };

  const confirmBreak = () => {
    fetch(`/api/schemes/members/${selectedMember.id}/break`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        withdrawnByCustomer: breakForm.withdrawnByCustomer,
        withdrawAmount: parseFloat(breakForm.withdrawAmount) || 0,
      }),
    })
      .then((r) => r.json())
      .then((updated) => {
        setMembers(
          members.map((m) => (m.id === selectedMember.id ? updated : m)),
        );
        setShowBreakModal(false);
      });
  };

  const reactivateMember = (id) => {
    fetch(`/api/schemes/members/${id}/status`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ status: "Active" }),
    })
      .then((r) => r.json())
      .then((updated) => {
        setMembers(members.map((m) => (m.id === id ? updated : m)));
      });
  };

  const inputStyle = {
    width: "100%",
    padding: "8px",
    background: "#C2B067",
    border: "1px solid #856A00",
    borderRadius: "6px",
    color: "#403301",
    fontSize: "13px",
  };
  const labelStyle = {
    fontSize: "12px",
    color: "#403301",
    display: "block",
    marginBottom: "4px",
  };

  return (
    <div
      style={{
        flex: 1,
        padding: "30px",
        color: "#403301",
        background: "#f8f9fa",
        minHeight: "100vh",
      }}
    >
      {/* Break Modal */}
      {showBreakModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              background: "#928243",
              border: "1px solid #856A00",
              borderRadius: "10px",
              padding: "24px",
              width: "400px",
            }}
          >
            <h3 style={{ marginTop: 0, color: "#403301" }}>
              Break Scheme — {selectedMember?.customerName}
            </h3>
            <div style={{ marginBottom: "12px" }}>
              <label style={labelStyle}>Total Paid so far</label>
              <div
                style={{
                  padding: "8px",
                  background: "#C2B067",
                  borderRadius: "6px",
                  color: "#403301",
                  fontSize: "13px",
                }}
              >
                ₹{selectedMember?.totalPaid || 0}
              </div>
            </div>
            <div style={{ marginBottom: "12px" }}>
              <label style={labelStyle}>Withdraw Amount (₹)</label>
              <input
                type="number"
                placeholder="Enter amount to withdraw"
                value={breakForm.withdrawAmount}
                onChange={(e) =>
                  setBreakForm({ ...breakForm, withdrawAmount: e.target.value })
                }
                style={inputStyle}
              />
            </div>
            <div
              style={{
                marginBottom: "16px",
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <input
                type="checkbox"
                id="withdrawn"
                checked={breakForm.withdrawnByCustomer}
                onChange={(e) =>
                  setBreakForm({
                    ...breakForm,
                    withdrawnByCustomer: e.target.checked,
                  })
                }
                style={{ width: "16px", height: "16px", cursor: "pointer" }}
              />
              <label
                htmlFor="withdrawn"
                style={{ ...labelStyle, margin: 0, cursor: "pointer" }}
              >
                Withdrawn by Customer
              </label>
            </div>
            <div style={{ display: "flex", gap: "10px" }}>
              <button
                onClick={confirmBreak}
                style={{
                  background: "#403301",
                  color: "#ef4444",
                  border: "1px solid #ef4444",
                  padding: "8px 20px",
                  borderRadius: "6px",
                  cursor: "pointer",
                }}
              >
                Confirm Break
              </button>
              <button
                onClick={() => setShowBreakModal(false)}
                style={{
                  background: "transparent",
                  color: "#403301",
                  border: "1px solid #856A00",
                  padding: "8px 20px",
                  borderRadius: "6px",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "24px",
        }}
      >
        <div>
          <h2 style={{ margin: 0 }}>Schemes</h2>
          <p style={{ margin: 0, color: "#856A00", fontSize: "12px" }}>
            {schemes.length} schemes · {members.length} members
          </p>
        </div>
        <div style={{ display: "flex", gap: "8px" }}>
          <button
            onClick={() => setShowSchemeForm(!showSchemeForm)}
            style={{
              background: "#403301",
              color: "gold",
              border: "1px solid #856A00",
              padding: "8px 16px",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "13px",
            }}
          >
            + New Scheme
          </button>
          <button
            onClick={() => setShowMemberForm(!showMemberForm)}
            style={{
              background: "#856A00",
              color: "gold",
              border: "none",
              padding: "8px 16px",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "13px",
            }}
          >
            + Enroll Member
          </button>
        </div>
      </div>

      {/* New Scheme Form */}
      {showSchemeForm && (
        <div
          style={{
            background: "#928243",
            border: "1px solid #856A00",
            borderRadius: "10px",
            padding: "20px",
            marginBottom: "16px",
          }}
        >
          <h3 style={{ marginTop: 0, color: "#403301" }}>New Scheme</h3>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr",
              gap: "12px",
            }}
          >
            <div>
              <label style={labelStyle}>Scheme Name</label>
              <input
                placeholder="Gold SIP 12M"
                value={schemeForm.name}
                onChange={(e) =>
                  setSchemeForm({ ...schemeForm, name: e.target.value })
                }
                style={inputStyle}
              />
            </div>
            <div>
              <label style={labelStyle}>Duration (months)</label>
              <input
                type="number"
                placeholder="12"
                value={schemeForm.durationMonths}
                onChange={(e) =>
                  setSchemeForm({
                    ...schemeForm,
                    durationMonths: e.target.value,
                  })
                }
                style={inputStyle}
              />
            </div>
            <div>
              <label style={labelStyle}>Monthly Amount (₹)</label>
              <input
                type="number"
                placeholder="5000"
                value={schemeForm.monthlyAmount}
                onChange={(e) =>
                  setSchemeForm({
                    ...schemeForm,
                    monthlyAmount: e.target.value,
                  })
                }
                style={inputStyle}
              />
            </div>
            <div>
              <label style={labelStyle}>Bonus Type</label>
              <select
                value={schemeForm.bonusType}
                onChange={(e) =>
                  setSchemeForm({ ...schemeForm, bonusType: e.target.value })
                }
                style={inputStyle}
              >
                <option value="">Select</option>
                <option>Free Month</option>
                <option>Free Making</option>
                <option>Discount 5%</option>
                <option>Free Hallmark</option>
              </select>
            </div>
            <div style={{ gridColumn: "span 2" }}>
              <label style={labelStyle}>Description</label>
              <input
                placeholder="Monthly gold savings scheme"
                value={schemeForm.description}
                onChange={(e) =>
                  setSchemeForm({ ...schemeForm, description: e.target.value })
                }
                style={inputStyle}
              />
            </div>
          </div>
          <div style={{ marginTop: "16px", display: "flex", gap: "10px" }}>
            <button
              onClick={saveScheme}
              style={{
                background: "#856A00",
                color: "gold",
                border: "none",
                padding: "8px 20px",
                borderRadius: "6px",
                cursor: "pointer",
              }}
            >
              Save Scheme
            </button>
            <button
              onClick={() => setShowSchemeForm(false)}
              style={{
                background: "transparent",
                color: "#403301",
                border: "1px solid #856A00",
                padding: "8px 20px",
                borderRadius: "6px",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      {/* Enroll Member Form */}
      {showMemberForm && (
        <div
          style={{
            background: "#928243",
            border: "1px solid #856A00",
            borderRadius: "10px",
            padding: "20px",
            marginBottom: "16px",
          }}
        >
          <h3 style={{ marginTop: 0, color: "#403301" }}>Enroll Member</h3>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr",
              gap: "12px",
            }}
          >
            <div>
              <label style={labelStyle}>Select Scheme</label>
              <select
                value={memberForm.schemeId}
                onChange={(e) =>
                  setMemberForm({ ...memberForm, schemeId: e.target.value })
                }
                style={inputStyle}
              >
                <option value="">Select</option>
                {schemes.map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.name}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label style={labelStyle}>Customer Name</label>
              <input
                placeholder="Meera Sharma"
                value={memberForm.customerName}
                onChange={(e) =>
                  setMemberForm({ ...memberForm, customerName: e.target.value })
                }
                style={inputStyle}
              />
            </div>
            <div>
              <label style={labelStyle}>Phone</label>
              <input
                placeholder="98XX XXXXXX"
                value={memberForm.customerPhone}
                onChange={(e) =>
                  setMemberForm({
                    ...memberForm,
                    customerPhone: e.target.value,
                  })
                }
                style={inputStyle}
              />
            </div>
            <div>
              <label style={labelStyle}>Start Date</label>
              <input
                type="date"
                value={memberForm.startDate}
                onChange={(e) =>
                  setMemberForm({ ...memberForm, startDate: e.target.value })
                }
                style={inputStyle}
              />
            </div>
            <div>
              <label style={labelStyle}>Maturity Date</label>
              <input
                type="date"
                value={memberForm.maturityDate}
                onChange={(e) =>
                  setMemberForm({ ...memberForm, maturityDate: e.target.value })
                }
                style={inputStyle}
              />
            </div>
            <div>
              <label style={labelStyle}>Monthly Amount (₹)</label>
              <input
                type="number"
                placeholder="5000"
                value={memberForm.monthlyAmount}
                onChange={(e) =>
                  setMemberForm({
                    ...memberForm,
                    monthlyAmount: e.target.value,
                  })
                }
                style={inputStyle}
              />
            </div>
          </div>
          <div style={{ marginTop: "16px", display: "flex", gap: "10px" }}>
            <button
              onClick={saveMember}
              style={{
                background: "#856A00",
                color: "gold",
                border: "none",
                padding: "8px 20px",
                borderRadius: "6px",
                cursor: "pointer",
              }}
            >
              Enroll
            </button>
            <button
              onClick={() => setShowMemberForm(false)}
              style={{
                background: "transparent",
                color: "#403301",
                border: "1px solid #856A00",
                padding: "8px 20px",
                borderRadius: "6px",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      {/* Scheme Cards */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "12px",
          marginBottom: "24px",
        }}
      >
        {schemes.length === 0 ? (
          <div
            style={{
              gridColumn: "span 3",
              padding: "30px",
              textAlign: "center",
              color: "#928243",
            }}
          >
            No schemes yet — click + New Scheme
          </div>
        ) : (
          schemes.map((s, i) => (
            <div
              key={i}
              style={{
                background: "#928243",
                border: "1px solid #856A00",
                borderRadius: "10px",
                padding: "16px",
              }}
            >
              <div
                style={{
                  fontWeight: "bold",
                  color: "#403301",
                  marginBottom: "8px",
                }}
              >
                {s.name}
              </div>
              <div
                style={{
                  fontSize: "12px",
                  color: "#403301",
                  lineHeight: "1.8",
                }}
              >
                <div>
                  Monthly: <strong>₹{s.monthlyAmount}</strong>
                </div>
                <div>Duration: {s.durationMonths} months</div>
                <div>
                  Bonus: <span style={{ color: "#856A00" }}>{s.bonusType}</span>
                </div>
                <div style={{ fontSize: "11px", marginTop: "4px" }}>
                  {s.description}
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "10px",
                }}
              >
                <span
                  style={{
                    background: s.isActive ? "#403301" : "#888",
                    color: s.isActive ? "#efbf04" : "#fff",
                    padding: "2px 8px",
                    borderRadius: "20px",
                    fontSize: "11px",
                  }}
                >
                  {s.isActive ? "Active" : "Inactive"}
                </span>
                <button
                  onClick={() => toggleScheme(s.id)}
                  style={{
                    background: "transparent",
                    color: s.isActive ? "#ef4444" : "#856A00",
                    border: `1px solid ${s.isActive ? "#ef4444" : "#856A00"}`,
                    padding: "3px 10px",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "11px",
                  }}
                >
                  {s.isActive ? "Deactivate" : "Activate"}
                </button>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Members Table */}
      <div
        style={{
          background: "#928243",
          border: "1px solid #856A00",
          borderRadius: "10px",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            padding: "14px 16px",
            borderBottom: "1px solid #856A00",
            color: "#403301",
            fontWeight: "bold",
          }}
        >
          Scheme Members
        </div>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ borderBottom: "1px solid #856A00" }}>
              {[
                "Member",
                "Phone",
                "Scheme",
                "Monthly",
                "Total Paid",
                "Start",
                "Maturity",
                "Break Date",
                "Withdrawn",
                "Withdraw Amt",
                "Status",
                "Action",
              ].map((h, i) => (
                <th
                  key={i}
                  style={{
                    padding: "10px 12px",
                    textAlign: "left",
                    fontSize: "11px",
                    color: "#403301",
                    textTransform: "uppercase",
                    whiteSpace: "nowrap",
                  }}
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {members.length === 0 ? (
              <tr>
                <td
                  colSpan="12"
                  style={{
                    padding: "30px",
                    textAlign: "center",
                    color: "#403301",
                  }}
                >
                  No members yet — click + Enroll Member
                </td>
              </tr>
            ) : (
              members.map((m, i) => (
                <tr key={i} style={{ borderBottom: "1px solid #856A00" }}>
                  <td
                    style={{
                      padding: "10px 12px",
                      fontSize: "13px",
                      color: "#403301",
                      fontWeight: "500",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {m.customerName}
                  </td>
                  <td
                    style={{
                      padding: "10px 12px",
                      fontSize: "13px",
                      color: "#403301",
                    }}
                  >
                    {m.customerPhone}
                  </td>
                  <td
                    style={{
                      padding: "10px 12px",
                      fontSize: "13px",
                      color: "#403301",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {schemes.find((s) => s.id === m.schemeId)?.name || "-"}
                  </td>
                  <td
                    style={{
                      padding: "10px 12px",
                      fontSize: "13px",
                      color: "#403301",
                    }}
                  >
                    ₹{m.monthlyAmount}
                  </td>
                  <td
                    style={{
                      padding: "10px 12px",
                      fontSize: "13px",
                      color: "#403301",
                    }}
                  >
                    ₹{m.totalPaid}
                  </td>
                  <td
                    style={{
                      padding: "10px 12px",
                      fontSize: "13px",
                      color: "#403301",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {new Date(m.startDate).toLocaleDateString("en-IN")}
                  </td>
                  <td
                    style={{
                      padding: "10px 12px",
                      fontSize: "13px",
                      color: "#403301",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {new Date(m.maturityDate).toLocaleDateString("en-IN")}
                  </td>
                  <td
                    style={{
                      padding: "10px 12px",
                      fontSize: "13px",
                      color: "#403301",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {m.breakDate
                      ? new Date(m.breakDate).toLocaleDateString("en-IN")
                      : "-"}
                  </td>
                  <td
                    style={{
                      padding: "10px 12px",
                      fontSize: "13px",
                      color: "#403301",
                    }}
                  >
                    {m.withdrawnByCustomer ? "Yes" : "No"}
                  </td>
                  <td
                    style={{
                      padding: "10px 12px",
                      fontSize: "13px",
                      color: "#403301",
                    }}
                  >
                    {m.withdrawAmount > 0 ? `₹${m.withdrawAmount}` : "-"}
                  </td>
                  <td style={{ padding: "10px 12px" }}>
                    <span
                      style={{
                        background: m.status === "Active" ? "#403301" : "#888",
                        color: m.status === "Active" ? "#efbf04" : "#fff",
                        padding: "2px 8px",
                        borderRadius: "20px",
                        fontSize: "11px",
                      }}
                    >
                      {m.status}
                    </span>
                  </td>
                  <td style={{ padding: "10px 12px" }}>
                    {m.status === "Active" ? (
                      <button
                        onClick={() => openBreakModal(m)}
                        style={{
                          background: "#403301",
                          color: "#ef4444",
                          border: "1px solid #ef4444",
                          padding: "4px 10px",
                          borderRadius: "4px",
                          cursor: "pointer",
                          fontSize: "11px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Break Scheme
                      </button>
                    ) : (
                      <button
                        onClick={() => reactivateMember(m.id)}
                        style={{
                          background: "#403301",
                          color: "#efbf04",
                          border: "1px solid #856A00",
                          padding: "4px 10px",
                          borderRadius: "4px",
                          cursor: "pointer",
                          fontSize: "11px",
                        }}
                      >
                        Reactivate
                      </button>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Schemes;
